import { createFileRoute, redirect } from '@tanstack/react-router'
import { PayslipDetailScreen } from '@/features/payslips/payslip-detail-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for one payslip.
 *
 * Same grant as the list — but the ROW-level answer is the API's: `show`
 * resolves the `payslip.view` scope and 403s any other payslip, so the screen
 * surfaces what the API grants rather than deciding it here.
 */
export const Route = createFileRoute('/_authenticated/payroll/payslips/$payslipId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'payslip.view')) {
      // A notification link reaches here without the grant: own payslips live on the phone.
      throw redirect({ to: '/get-the-app' })
    }
  },
  component: PayrollPayslipDetailRoute,
})

function PayrollPayslipDetailRoute() {
  const { payslipId } = Route.useParams()

  return <PayslipDetailScreen payslipId={payslipId} />
}
